import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IoIosCheckmark, IoIosMore } from "react-icons/io";
import { IoMdCreate } from 'react-icons/io';
import { IoWarning } from 'react-icons/io5';
import { FaThumbsUp, FaCheckCircle } from 'react-icons/fa';
import { GiCircle } from "react-icons/gi";
import { GrDrag } from 'react-icons/gr';
import { Api } from '../../../../services/api';
import LongTermDragabble from './LongTermDragabble';

const statusOptions = [
    { value: 'Off Track', label: 'Off Track', icon: <IoWarning style={{ color: 'red', fontSize: '20px' }} /> },
    { value: 'On Track', label: 'On Track', icon: <FaThumbsUp style={{ color: '#48994B', fontSize: '20px' }} /> },
    { value: 'Complete', label: 'Complete', icon: <FaCheckCircle style={{ color: '#2F8DAC', fontSize: '20px' }} /> },
];

const CustomDropdown = ({ options, selectedValue, onChange, isEditing }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        // Add click event listener to document
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Remove event listener on cleanup
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleOptionClick = (option) => {
        if (!isEditing) return;
        onChange(option.value);
        setIsOpen(false);
    };

    return (
        <div ref={dropdownRef} style={{ position: 'relative' }}>
            <div
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '5px',
                    borderRadius: '4px',
                }}
            >
                {options.map((option) => (
                    option.value === selectedValue && (
                        <span key={option.value} style={{ display: 'flex', alignItems: 'center' }}>
                            {option.icon}
                        </span>
                    )
                ))}
            </div>
            {isOpen && (
                <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    background: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    zIndex: 1000,
                    width: '8vw',
                    padding: '12px'
                }}>
                    {options.map((option) => (
                        <div
                            key={option.value}
                            onClick={() => handleOptionClick(option)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px',
                                cursor: 'pointer',
                            }}
                        >
                            <span style={{ marginRight: '8px' }}>{option.label}</span>
                            {option.icon}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

function LongTermIssues() {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [editingRowId, setEditingRowId] = useState(null);
    const [newTitle, setNewTitle] = useState('');
    const [hoveredRowId, setHoveredRowId] = useState(null);
    const [draggedRowId, setDraggedRowId] = useState(null);
    const [dragging, setDragging] = useState(false);

    const [workMotivators, setWorkMotivators] = useState([]);
    const [workMotivatorsComment, setWorkMotivatorsComment] = useState('');

    const initialCustomers = [
        { id: 1, status: '', title: 'Issue 1', created: '2023-01-01', owner: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIGKcO47FJXGbn-gnAsAn4Ad88cJxHeoQqnpyaVXeiMyTRnuk7IfqSvDmQpWJvoL5sR1Q&usqp=CAU' },
        { id: 2, status: 'Complete', title: 'Issue 2', created: '2023-01-02', owner: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4mfcCBaUG6YTp9y_QD0OBm9SVoPZjj_hjT2CQhq17whHvcttXcBJh1nPf-7N-tu-hTAk&usqp=CAU' },
        { id: 3, status: 'Off Track', title: 'Issue 3', created: '2023-01-03', owner: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQphnRKlyvM_8IVmb89zy638Y_uStmu75bSc6YDmdMX32iABjxadlXv2qzT4l56zta0w84&usqp=CAU' },
        { id: 4, status: 'Off Track', title: 'Issue 3', created: '2023-01-03', owner: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQphnRKlyvM_8IVmb89zy638Y_uStmu75bSc6YDmdMX32iABjxadlXv2qzT4l56zta0w84&usqp=CAU' },
        { id: 5, status: 'On Track', title: 'Issue 3', created: '2023-01-03', owner: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQphnRKlyvM_8IVmb89zy638Y_uStmu75bSc6YDmdMX32iABjxadlXv2qzT4l56zta0w84&usqp=CAU' },
        { id: 6, status: 'Off Track', title: 'Issue 3', created: '2023-01-03', owner: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQphnRKlyvM_8IVmb89zy638Y_uStmu75bSc6YDmdMX32iABjxadlXv2qzT4l56zta0w84&usqp=CAU' },
    ];


    useEffect(() => {
        fetchData();
        const adminStatus = localStorage.getItem('isAdmin');
        setIsAdmin(adminStatus === 'Y');
    }, []);

    const fetchData = async () => {
        const token = localStorage.getItem('authToken');
        const response = await fetch(Api.API_BASE_URL + 'business-core/goal/long-term-issue/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : '',
            },
        });

        if (response.ok) {
            const data = await response.json();
            if (data.result && data.result.company_rocks && data.result.company_rocks.length > 0) {
                setCustomers(data.result.company_rocks.map(item => ({
                    id: item.id,
                    status: item.status,
                    title: item.title,
                    created: item.created_at,
                    owner: item.owner,
                    rating: item.rating,
                })));
            } else {
                setCustomers(initialCustomers); // Fallback to initial data if API returns empty
            }
        } else {
            console.error('Failed to fetch data');
            setCustomers(initialCustomers); // Fallback if API fails
        }
    };


    const handleEdit = (row) => {
        setEditingRowId(row.id);
        setNewTitle(row.title);
        setIsEditing(true);
    };

    const handleTitleChange = (rowId) => {
        setCustomers((prevCustomers) =>
            prevCustomers.map((customer) =>
                customer.id === rowId ? { ...customer, title: newTitle } : customer
            )
        );
        setEditingRowId(null);
    };

    const handleStatusChange = (id, newStatus) => {
        const updatedCustomers = customers.map((customer) =>
            customer.id === id ? { ...customer, status: newStatus } : customer
        );

        setCustomers(updatedCustomers);


        const saveStatusChange = async () => {
            const token = localStorage.getItem('authToken');
            try {
                const response = await fetch(Api.API_BASE_URL + 'business-core/goal/long-term-issue/save', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token ? `Bearer ${token}` : '',
                    },
                    body: JSON.stringify(updatedCustomers.map(customer => ({
                        ...customer,
                        number: customer.rating
                    }))),
                });

                if (!response.ok) {
                    console.error('Failed to save status');
                    // Optionally, revert the local state if save fails
                    setCustomers(customers);
                }
            } catch (error) {
                console.error('Error saving status:', error);
                // Optionally, revert the local state if save fails
                setCustomers(customers);
            }
        };

        saveStatusChange();
    };

    const handleNumberChange = (id, newRating) => {
        setCustomers((prevCustomers) =>
            prevCustomers.map((customer) =>
                customer.id === id ? { ...customer, rating: newRating } : customer
            )
        );
    };

    const handleDragStart = (id) => {
        console.log(`Dragging row with id: ${id}`);
        setDraggedRowId(id);
        setDragging(true);
    };

    const handleDragOver = (e, id) => {
        e.preventDefault();
        if (draggedRowId !== id) {
            setHoveredRowId(id); // Highlight the row you're hovering over
        }
    };

    const handleDrop = (id) => {
        console.log(`Dropped on row with id --------> : ${id}`);
        if (draggedRowId === id) return;

        const draggedOverItem = customers.find(item => item.id === id);
        const draggedItem = customers.find(item => item.id === draggedRowId);

        if (draggedOverItem && draggedItem) {
            const newData = [...customers];
            const draggedIndex = newData.findIndex(item => item.id === draggedRowId);
            const hoveredIndex = newData.findIndex(item => item.id === id);

            newData.splice(draggedIndex, 1);
            newData.splice(hoveredIndex, 0, draggedItem);

            // console.log("newData ------->", newData)

            setCustomers(newData);
        }

        setDraggedRowId(null); // Reset the dragged item
    setHoveredRowId(null); // Reset hovered row when drop is complete
    setDragging(false);
    };

    const handleDragEnd = () => {
        setDragging(false); // Reset dragging state when drag ends
    };

    const handleSave = async () => {
        const token = localStorage.getItem('authToken');
        const response = await fetch(Api.API_BASE_URL + 'business-core/goal/long-term-issue/save', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : '',
            },
            body: JSON.stringify(customers.map(customer => ({
                ...customer,
                number: customer.rating // Change number to rating here
            }))),
        });
        if (response.ok) {
            // Handle successful save
            setIsEditing(false);
        } else {
            // Handle error
            console.error('Failed to save issues');
        }
    };

    return (
        <div className="">
            <div className="box-header">
                <h4 className='subtitle-font'>Long-Term Issues</h4>
                {isAdmin && (
                    !isEditing ? (
                        <IoMdCreate
                            onClick={handleEdit}
                            style={{
                                fontSize: '20px',
                                cursor: 'pointer',
                            }}
                        />
                    ) : (
                        <IoIosCheckmark
                            onClick={handleSave}
                            style={{
                                fontSize: '40px',
                                cursor: 'pointer',
                            }}
                        />
                    )
                )}
            </div>

            <div className="box-body">
                <DataTable value={customers} paginator rows={5} reorderableRows rowsPerPageOptions={[5, 10, 25, 50]}>
                    {/* <Column
                        header=""
                        body={(rowData, options) => (
                            <div
                                draggable
                                onDragStart={() => handleDragStart(rowData.id)}
                                onDragOver={(e) => handleDragOver(e, rowData.id)}
                                onDrop={() => handleDrop(rowData.id)}
                                onDragEnd={handleDragEnd}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'grab',
                                    border: draggedRowId === rowData.id && dragging ? '2px dashed blue' : 'none', 
                                }}
                            >
                                <GrDrag
                                    style={{ fontSize: '15px', color: '#888', cursor: 'grab', background: 'red' }}
                                />
                            </div>
                        )}
                        style={{ width: '5%', textAlign: 'center' }}
                    /> */}
                    <Column
                        header=""
                        body={(rowData) => (
                            rowData.status ? (
                                <CustomDropdown
                                    options={statusOptions}
                                    selectedValue={rowData.status}
                                    onChange={(newStatus) => handleStatusChange(rowData.id, newStatus)}
                                    isEditing={isAdmin}
                                />
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <GiCircle
                                        style={{ fontSize: '20px' }}
                                        onClick={() => handleStatusChange(rowData.id, 'Off Track')}
                                    />
                                </div>
                            )
                        )}
                        style={{ width: '10%', textAlign: 'center' }}
                    />


                    <Column
                        field="title"
                        header="Title"
                        body={(rowData) => (
                            <div
                                onMouseEnter={() => setHoveredRowId(rowData.id)}
                                onMouseLeave={() => setHoveredRowId(null)}
                                draggable
                                onDragStart={() => handleDragStart(rowData.id)}
                                onDragOver={handleDragOver}
                                onDrop={() => handleDrop(rowData.id)}
                                style={{ display: 'flex', alignItems: 'center' }}
                            >
                                {editingRowId === rowData.id ? (
                                    <input
                                        type="text"
                                        value={newTitle}
                                        onChange={(e) => setNewTitle(e.target.value)}
                                        onBlur={() => handleTitleChange(rowData.id)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleTitleChange(rowData.id);
                                            }
                                        }}
                                        style={{ flex: 1, marginRight: '8px' }}
                                    />
                                ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', height:"60px" }}>
                                        <span>{rowData.title}</span>
                                        {hoveredRowId === rowData.id && (
                                            <IoMdCreate
                                                onClick={() => handleEdit(rowData)}
                                                style={{
                                                    textAlign: 'center',
                                                    fontSize: '20px',
                                                    cursor: 'pointer',
                                                    marginLeft: '5px',
                                                }}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    />
                    <Column
                        header="#"
                        body={(rowData) => (
                            <select
                                value={rowData.rating || 1}
                                onChange={(e) => handleNumberChange(rowData.id, e.target.value)}
                                style={{ width: '100%', border: 'none', borderBottom: '1px solid #ccc', padding: '5px' }}
                            >
                                {[1, 2, 3, 4, 5].map(num => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                            </select>
                        )}
                        style={{ width: '10%', textAlign: 'center' }}
                    />
                    <Column field="created" header="Created" style={{ width: '15%' }} />
                    <Column
                        header="Owner"
                        body={(rowData) => (
                            <img
                                src={rowData.owner}
                                alt="Owner"
                                style={{ width: '30px', height: '30px', borderRadius: '50%' }}
                            />
                        )}
                        style={{ width: '5%', textAlign: 'center' }}
                    />
                    <Column
                        header=""
                        body={(rowData) => (
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                <IoIosMore />
                            </div>
                        )}
                        style={{ width: '2%', textAlign: 'center' }}
                    />
                </DataTable>
            </div>
            <button className='btn btn-light'>Add Issue</button>
        </div>

    );
}

export default LongTermIssues;